/**
 * Created by Dimitri Sebeschuk on 04.05.17.
 *
 * Wrapper for CQ_Analytics.TestTarget
 * see: /etc/clientlibs/foundation/testandtarget/util/js.txt
 *
 * Fix "targetoffer" selector
 */
// jshint camelcase: false
(function (CQ_Analytics, CQ, SCS, $, debug) {
	'use strict';

	if (!CQ_Analytics || !CQ_Analytics.TestTarget || !CQ) {
		return;
	}

	var obj = CQ_Analytics.TestTarget;

	var origGet = CQ.shared.HTTP.get,
		origPull = obj.pull;

	SCS.TestTarget = SCS.TestTarget || {};

	SCS.TestTarget.transformProxyUrl = function (url) {
		var suffixIndex = url.indexOf('.html/'),
			baseUlr = suffixIndex > -1 ? url.substring(0, suffixIndex) : url,
			selectors = baseUlr.substring(baseUlr.indexOf('.'), baseUlr.lastIndexOf('.') + 1).split('.'),
			//support mobile selector in Browser
			mobile = $.inArray('mobile', selectors) !== -1 ? '.mobile' : '',
			basePath = baseUlr.indexOf('.') > -1 ? baseUlr.substring(0, baseUlr.indexOf('.')) : baseUlr,
			suffixUrl = suffixIndex > -1 ? url.substring(suffixIndex + 5) : '',
			suffixPath = suffixUrl.substring(0, suffixUrl.indexOf('.')),
			suffixSelectors = suffixUrl.substring(suffixUrl.indexOf('.'), suffixUrl.lastIndexOf('.') + 1).split('.'),
			query = window.location.search.indexOf('wcmmode=disabled') > 0 ? '?wcmmode=disabled' : '';

		if (suffixUrl.length === 0) {
			return basePath + mobile + '.scstargetoffer.html' + query;
		}

		selectors = selectors.filter(function (it) {
			return it !== 'mobile' && it !== 'targetoffer' && it.length > 0;
		});
		selectors = selectors.length > 0 ? '.' + selectors.join('.') : '';

		suffixSelectors = suffixSelectors.filter(function (it) {
			return it.length > 0;
		});
		//tandt selector or empty
		suffixSelectors = suffixSelectors.length > 0 ? '.' + suffixSelectors.join('.') : '';

		//sling on selectors to the suffix url
		return basePath + mobile + '.scstargetoffer.html' + suffixPath + suffixSelectors + selectors + '.html' + query;
	};

	/**
	 * Fetches the resource from provided path and writes the
	 * response to the document or the mbox Element if
	 *
	 * <ul>
	 * <li>response status code is 200</li>
	 * <li>response has a body with length > 0</li>
	 * </ul>
	 *
	 * Uses a synchronous call for requesting the resource. If a WCM mode is defined this
	 * call forces the resource to be rendered with WCM mode disabled.
	 *
	 * @static
	 * @param {String} path Path to document/node to request.
	 * @param {String} mboxName The name of the mbox that issued the request
	 */
	obj.pull = function (path, mboxName) {

		CQ.shared.HTTP.get = function (proxyUrl) {
			CQ.shared.HTTP.get = origGet;
			// pull in the content
			var output = origGet.call(this, SCS.TestTarget.transformProxyUrl(proxyUrl)),
				isOk = (output && output.status && output.status === 200),
				hasBody = (output && output.body && output.body.length > 0);

			if (isOk && !hasBody) {
				//try to get default content
				debug.warn('SCS Target -> pull(): The offer is not found, try to get default content.');
				if (typeof obj.defaults[mboxName] === 'undefined') {
					debug.error('SCS Target -> pull(): The default offer path was not found in the internal map for mbox ' + mboxName);
					return output;
				}
				var defaultContentPath = obj.defaults[mboxName],
					url = document.location.pathname,
					defaultProxyUrl = url + defaultContentPath;
				output = origGet.call(this, SCS.TestTarget.transformProxyUrl(defaultProxyUrl));
			}

			return output;
		};
		var result = origPull.apply(this, arguments);
		return result;
	};

	function onTargetDomLoaded(e) {
		if (!SCS || !SCS.utils || !SCS.utils.initNewModules) {
			return;
		}
		SCS.utils.initNewModules(e.target);
	}

	$('body').on('target-dom-loaded', onTargetDomLoaded);

})(window.CQ_Analytics, window.CQ, window.SCS = window.SCS || {}, window.$, window.debug || window.console);



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/foundation/testandtarget/util/source/init.js
// module id = 368
// module chunks = 0